import {Component} from '@angular/core';
import {Block} from "../../../block";
import {DomSanitizer} from '@angular/platform-browser';
import {Theme} from "../../../../models/util";

@Component({
    selector: 'app-hero-tile',
    templateUrl: './hero-tile.component.html',
})
export class HeroTileComponent extends Block {

    safeURL = this.sanitizer.bypassSecurityTrustUrl('javascript:void(0)');

    constructor(private sanitizer: DomSanitizer) {
        super();
    }
}
